export function generatePaymentSchedule(startDate, endDate, totalAmount) {
    const quarters = [];
    let currentQuarterDate = new Date(startDate);
    let numberOfQuarters = 0;

    while (currentQuarterDate < endDate) {
        numberOfQuarters++;
        currentQuarterDate.setMonth(currentQuarterDate.getMonth() + 3);
    }

    const amountPerQuarter = totalAmount / numberOfQuarters;
    currentQuarterDate = new Date(startDate);

    while (currentQuarterDate < endDate) {
        const year = currentQuarterDate.getFullYear();
        const quarter = Math.floor(currentQuarterDate.getMonth() / 3) + 1;

        let quarterStart, quarterEnd;
        if (quarter === 1) {
            quarterStart = new Date(year, 0, 1);
            quarterEnd = new Date(year, 2, 31);
        } else if (quarter === 2) {
            quarterStart = new Date(year, 3, 1);
            quarterEnd = new Date(year, 5, 30);
        } else if (quarter === 3) {
            quarterStart = new Date(year, 6, 1);
            quarterEnd = new Date(year, 8, 30);
        } else if (quarter === 4) {
            quarterStart = new Date(year, 9, 1);
            quarterEnd = new Date(year, 11, 31);
        }

        const paymentDate = new Date(quarterEnd.getFullYear(), quarterEnd.getMonth(), 5);

        quarters.push({
            quarter: quarter,
            start: quarterStart,
            end: quarterEnd,
            paymentDate: paymentDate,
            amount: amountPerQuarter.toFixed(3)
        });

        currentQuarterDate.setMonth(currentQuarterDate.getMonth() + 3);
    }
    return quarters;
}

